/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Liwg
 * @date  2025/05/06 18:04
 * @des 本模块的字符串国际化
 */
import CN from './cn'
import EN from './en'

export default {
  cn: CN,
  en: EN
}



// WEBPACK FOOTER //
// ./src/pad-control/i18n/message.js